module.exports = CryptoJS;